<template>
<div>
  <section class="content">
     <!-- Default box -->
      <div class="info-box"  v-if="canAccess('leave-type-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Download Forms</h3>
          
          <div class="box-tools">
            <!-- <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('leave-type-create')">
              <i class="fa fa-plus"></i> Add New
            </button> -->
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <a :href="`${this.$axios.defaults.baseURL}/loanapplicationformpdf/${user_id}`" class="btn btn-box-tool">View Loan Application Form
                </a>
                <!-- <button type="button" @click="changeFilter()" class="btn btn-info"><i class="fa fa-download"></i> Loan Application Form</button> -->
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <a :href="`${this.$axios.defaults.baseURL}/loanapplicationformpdf/${user_id}?download=download`" class="btn btn-box-tool"><i class="fa fa-download"></i> Loan Application Form Download
                </a>
              <!-- <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <button type="button" @click="changeFilter()" class="btn btn-info"><i class="fa fa-download"></i> Loan Application Form</button>
              </div> -->
            </div>
          </div>
                
        </div>
      </div>
      <!-- /.box -->
  </section>    
  <div class="modal fade" id="newModal">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header bg-aqua">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 v-show="!editMode" class="modal-title">Add New</h4>
          <h4 v-show="editMode" class="modal-title">Update</h4>
          
        </div>
        <form @submit.prevent.once="editMode ? updateLeaveType() : createLeaveType()">
          <div class="modal-body">
            <!-- general form elements disabled -->
            <div class="card card-warning">
              <!-- /.card-header -->
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-6">
                    <!-- text input -->
                    <div class="form-group">
                      <label>Name <span class="red">*</span></label>
                      <input
                        v-model="form.name"
                        type="text"
                        name="name"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('name') }"
                      />
                      <has-error :form="form" field="name"></has-error>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label
                        >Select Status <span class="red">*</span></label
                      >
                      <select
                        v-model="form.status"
                        name="status"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('status'),
                        }"
                      >
                        <option v-if="!form.status" selected value="">
                          Select Status
                        </option>
                        <option value="active">Active</option>
                        <option value="inActive">Inactive</option>
                      </select>
                      <has-error :form="form" field="status"></has-error>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <div class="modal-footer text-center">
            <button
              v-show="!editMode"
              type="submit"
              class="btn btn-success"
            >
              CREATE
            </button>
            <button v-show="editMode" type="submit" class="btn btn-success">
              UPDATE
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
            >
              CANCEL
            </button>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->   
</div>
</template>

<script>
export default {
  name: 'DownloadForm',
  data () {
    return {
      user_id: '',
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      editMode: false,
      form: new Form({
        id: '',
        name: '',
        status: ''
      }),
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModal () {
      this.editMode = false
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      // $('#newModal').modal('show')
    },

    createLeaveType () {
      this.$axios
        .post('leavetype', this.form, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Leave Type Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },

    editModal (row) {
      this.editMode = true
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      // $('#newModal').modal('show')
      this.form.fill(row)
    },
    updateLeaveType () {
      // console.log('update data')

      this.$axios
        .put('leavetype/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Leave Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    changeFilter (page = null, pg = null) {
      var c = JSON.parse(localStorage.user)
      this.user_id = c.id
    }
    // loadData () {
    //   let loader = this.$loading.show()
    //   this.$axios
    //     .get('bank?all=all', {
    //       headers: { Authorization: 'Bearer ' + localStorage.token }
    //     })
    //     .then((response) => response.data)
    //     .then((data) => {
    //       loader.hide()
    //       this.rows = data.data
    //     })
    //     .catch(function (error) {
    //       Swal.fire({
    //         icon: 'error',
    //         title: 'Oops...',
    //         text: error
    //       })
    //     })
    // }
  },

  created () {
    this.changeFilter()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// DownloadLoanForm.vue?f32871f2